import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { Product } from '../interfaces/product.interface';
import { ProductcodeService } from "../services/productcode";
import { RouterLink,  Router} from '@angular/router';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule, FormGroup, FormBuilder  } from '@angular/forms';

@Component({
  selector: 'app-product',
  imports: [RouterLink, FormsModule, ReactiveFormsModule],
  templateUrl: './product.html',
  styleUrl: './product.css',
})
export class ProductComponent {
public products: Product[] = [];
  myForm: FormGroup;

  constructor( 
      private productcodeService: ProductcodeService, 
      private cdr: ChangeDetectorRef, 
      private router: Router,
      private fb: FormBuilder) 
                {
                  this.myForm = this.fb.group({
  
                });
      this.getProducts();
    }

  public async getProducts(): Promise<void> {
 
    try {
    this.products = await this.productcodeService.getProductcodes();
    this.cdr.detectChanges();
    } catch (error) {
      console.error('getProducts error',error);
    }
    
  }
  onEdit(product: Product): void {
     this.productcodeService.selectedProduct = product;
    this.router.navigateByUrl('editproduct')
  }

async deleteProduct(product: Product): Promise<void>{
    const confirmation = window.confirm(`Are you sure you want to delete ${product.description + " - " + product.description2}?`);
    if (!confirmation) {
       return;
    }
    try
    {
           await this.productcodeService.deleteProduct(product.id);
            this.getProducts();
            this.cdr.detectChanges();
            this.router.navigateByUrl('product')
 
    } catch (error) {
           console.error('deleteproduct error',error);
    }
  }

}
